<div
  class="cstmInputBox"
  [style]="cstmStyle"
  [ngClass]="{ error: error }"
  [class]="classes"
>
  <label [class.focused]="isFocused">{{ label }}</label>
  <fa-icon [icon]="icon"></fa-icon>
  @if (inputType == "textArea") {
    <textarea
      [rows]="rows"
      (input)="write($event)"
      [readOnly]="readOnly || loader"
      [placeholder]="placeholder"
      [class.show-placeholder]="isFocused"
      (focus)="togglePlaceholder(true)"
      [(ngModel)]="form.controls[control].value"
      (blur)="togglePlaceholder(false)"
      appCharacterLimit
      [limit]="limit"
    ></textarea>
  } @else if (inputType == "phone") {
    <ngx-intl-tel-input
      (input)="write($event)"
      (countryChange)="onCountryChange($event)"
      cssClass="customPhoneFlagInput border-0"
      [enableAutoCountrySelect]="true"
      [enablePlaceholder]="true"
      [searchCountryFlag]="true"
      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
      [selectFirstCountry]="false"
      [selectedCountryISO]="selectedCountryISO"
      [maxLength]="15"
      [phoneValidation]="true"
      [(ngModel)]="form.controls[control].value"
      [separateDialCode]="true"
      [numberFormat]="PhoneNumberFormat.International"
    ></ngx-intl-tel-input>
  } @else if (inputType == "select") {
    <select
      (change)="write($event)"
      [class.show-placeholder]="isFocused"
      (focus)="togglePlaceholder(true)"
      [(ngModel)]="form.controls[control].value"
      (blur)="togglePlaceholder(false)"
    >
      @for (item of array; track $index) {
        <option [value]="item?.title">
          {{ item?.title }}
        </option>
      }
    </select>
  } @else {
    @if (NumbersOnly) {
      <input
        [type]="type"
        (input)="
          write($event);
          password && checkStrength($event);
          prefixs && onPrefixChange($event)
        "
        [readOnly]="readOnly || loader"
        [placeholder]="placeholder"
        [class.show-placeholder]="isFocused"
        NumbersOnly
        (focus)="togglePlaceholder(true)"
        [(ngModel)]="form.controls[control].value"
        (blur)="togglePlaceholder(false)"
        appCharacterLimit
        [limit]="limit"
      />
    } @else {
      <input
        [type]="type"
        (input)="
          write($event);
          password && checkStrength($event);
          prefixs && onPrefixChange($event)
        "
        [readOnly]="readOnly || loader"
        [placeholder]="placeholder"
        [class.show-placeholder]="isFocused"
        (focus)="togglePlaceholder(true)"
        [(ngModel)]="form.controls[control].value"
        (blur)="togglePlaceholder(false)"
        appCharacterLimit
        [limit]="limit"
      />
    }
  }
  @if (toolTip && (resize.windowSize$ | async)?.width > 1024) {
    <fa-icon
      [icon]="faInfoCircle"
      class="circle cursor"
      [ngbTooltip]="toolTip"
      [autoClose]="false"
      #tooltip="ngbTooltip"
      container="body"
    ></fa-icon>
  }
  @if (password) {
    <fa-icon
      [icon]="type == 'password' ? faEye : faEyeSlash"
      class="circle eye cursor"
      [ngClass]="{ eyeRight: (resize.windowSize$ | async)?.width <= 1024 }"
      (click)="type = type === 'text' ? 'password' : 'text'"
    ></fa-icon>
  }
</div>
@if (password && value?.length > 0 && meter) {
  <div class="meter-text mt-2">
    <span>Password Strength: </span>
    <span class="meter-status" [ngStyle]="{ color: meterStatusColor }">{{
      content
    }}</span>
    @if (content != "Too Short") {
      <fa-icon [icon]="faCheckCircle" class="text-success ms-1"></fa-icon>
    } @else {
      <fa-icon [icon]="faTimesCircle" class="text-danger ms-1"></fa-icon>
    }
  </div>
  <div class="meter" id="meter">
    <div
      class="meter-bar"
      [ngStyle]="{ 'background-color': meterStatusColor, width: meterBarWidth }"
    ></div>
  </div>
}
@if (error && errorName) {
  <small class="text-danger"
    ><fa-icon [icon]="faExclamationCircle"></fa-icon>
    {{
      errorName == "required"
        ? label +
          "
  Required"
        : errorName == "minlength"
          ? "Minimum " +
            form.controls[control]?.errors?.[errorName]?.requiredLength +
            "
  required"
          : errorName == "maxlength"
          ? "Maximum " +
            form.controls[control]?.errors?.[errorName]?.requiredLength +
            "
  allowed"
          :errorName == "max"
          ? "Maximum " +
            form.controls[control]?.errors?.[errorName]?.max +
            "
  allowed"
          :returnFirstLetterCapital(
              form.controls[control].status?.toLowerCase()
            ) +
            " " +
            label
    }}
  </small>
}
